import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const { REACT_APP_API_KEY } = process.env;

const useGetPatientListOfMMUhead = ({ currentPage, selectedHeadID }) => {
  const navigate = useNavigate();
  const [patientList, setPatientList] = useState([]);
  const [isPatientListLoading, setIsPatientListLoading] = useState(false);

  const getPatientList = useCallback(async () => {
    setIsPatientListLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `/api/v1/visit/search`,
        {
          params: { mmuHead: selectedHeadID, page: currentPage - 1 },
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      setPatientList(res.data);
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      }
    } finally {
      setIsPatientListLoading(false);
    }
  }, [currentPage, selectedHeadID, navigate]);

  useEffect(() => {
    if (selectedHeadID !== null) {
      getPatientList();
    }
  }, [currentPage, getPatientList, selectedHeadID]);

  return {
    patientList,
    isPatientListLoading,
    getPatientList,
  };
};

export default useGetPatientListOfMMUhead;
